module.exports = __webpack_public_path__ + "static/media/14UNEP9.8d83efc0.jpg";